import { CoverageBadge, CoverageStatus } from '@/components/CoverageBadge';

interface CoverageRowData {
  service: string;
  outpostPersonal: CoverageStatus;
  outpostGuest: CoverageStatus;
  summit: CoverageStatus;
}

interface CoverageMobileRowProps {
  row: CoverageRowData;
  isAlternate: boolean;
}

function CoverageMobileRow({ row, isAlternate }: CoverageMobileRowProps) {
  return (
    <div className={`px-4 py-3 ${isAlternate ? 'bg-gray-50' : ''}`}>
      <div className="mb-3 text-sm font-semibold text-gray-900">{row.service}</div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-600">X-OUTPOST (Personal)</span>
          <CoverageBadge value={row.outpostPersonal} isMobile />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-600">X-OUTPOST (Guest)</span>
          <CoverageBadge value={row.outpostGuest} isMobile />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-600">X-SUMMIT (Personal)</span>
          <CoverageBadge value={row.summit} isMobile />
        </div>
      </div>
    </div>
  );
}

export { CoverageMobileRow };
export type { CoverageRowData };
